import { useCallback } from 'react';

import { useMenuContext } from 'state/menu';
import { UserSelectionModifierSlotMap } from 'state/product-wizard-v2/types';

import { getProductPropsSelections } from './utils';

export const useProductPropsSelections = () => {
  const { priceForItemOptionModifier } = useMenuContext();

  const buildProductPropsSelections = useCallback(
    (modifierSelections: UserSelectionModifierSlotMap) =>
      getProductPropsSelections({
        modifierSelections,
        priceForItemOptionModifier,
      }),
    [priceForItemOptionModifier]
  );

  return {
    buildProductPropsSelections,
  };
};
